import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import AlertContext from '../../Context/Alert/AlertContext';
import { BaseURL } from '../../Files/BaseURL';
import SocketContext from '../../Context/Socket/SocketContext'
import io from "socket.io-client";

const Negotiate = ({ Seller }) => {
    const [message, setMessage] = useState('I would like to change the size of these sneakers. At the moment they are less than needed. So I would like to get others like this, but a size larger. Thank you!');
    const [isEditable, setIsEditable] = useState(true);
    const [negotiationStatus, setNegotiationStatus] = useState('Pending');
    const [hasNegotiation, setHasNegotiation] = useState(false);
    const [btnClicked, setBtnClicked] = useState(false);

    const socketcontext = useContext(SocketContext);
    const { OnlineUsers, SocketConnection, isUserOnline, setSocetConnection } = socketcontext;

    const { sentid } = useParams();
    let { recivedid } = useParams();
    const { showAlert } = useContext(AlertContext);


    const initials = async () => {
        if (Seller) {
            setIsEditable(false)
        }

        if (!recivedid) {
            recivedid = sentid;
        }

        const offer = await fetch(`${BaseURL}/api/negotiateOffer/NegotiateOffer/${recivedid}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'auth-token': localStorage.getItem('p@token')
            }
        });

        if (!offer.ok) {
            return;
        }
        const result = await offer.json();
        if (result) {
            setHasNegotiation(true);
            setMessage(result.Message);
            setNegotiationStatus(result.Status);
        }

    };

    let socketConnection = SocketConnection;
    const setSocket = () => {
        const authToken = localStorage.getItem('p@token');
        socketConnection = io(BaseURL, {
            auth: {
                token: authToken,
            },
        });
        setSocetConnection(socketConnection);
    }

    useEffect(() => {
        initials();
    }, [sentid, recivedid]);


    if (Seller && !hasNegotiation) {
        return null;
    }

    const buttonHandler = async () => {
        setBtnClicked(true);
        const auth = localStorage.getItem('p@token');
        if (!recivedid) {
            recivedid = sentid;
        }

        if (Seller) {
            const res = await fetch(`${BaseURL}/api/negotiateOffer/updateStatus/${recivedid}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': auth
                },
                body: JSON.stringify({
                    Message: message
                })
            });
            if (!res.ok) {
                showAlert('Error accepting the offer', 'error');
                return;
            }
            setNegotiationStatus('Accepted');
            if (SocketConnection)
                SocketConnection.emit("Negotiation", { offerId: recivedid, status: 'In progress' });
            else {
                setSocket();
                if (socketConnection) {
                    socketConnection.emit('Negotiation', {
                        status: 'In progress',
                        offerId: recivedid
                    });
                }
            }
            showAlert('Negotiation accepted successfully', 'success');

        }
        else {

            const res = await fetch(`${BaseURL}/api/negotiateOffer/CreateNegotiateOffer`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': auth
                },
                body: JSON.stringify({
                    OfferId: sentid || recivedid,
                    Message: message
                })
            });
            if (!res.ok) {
                showAlert('Error sending the negotiation request', 'error');
                return;
            }
            if (SocketConnection)
                SocketConnection.emit("Negotiation", { offerId: recivedid });
            else {
                setSocket();
                if (socketConnection) socketConnection.emit('Negotiation', {
                    offerId: recivedid
                });
            }
            showAlert('Negotiation request sent successfully. Waiting for approval', 'success');
        }
    };

    return (
        <>
            {!btnClicked && (
                <div className='bg-[#FEF8EE] flex flex-col gap-2 rounded-xl py-4 px-4 w-fit max-w-sm'>
                    <h2 className='text-xl font-semibold'>Negotiate delivery</h2>
                    <div className="bg-white border-[#E9E9E9] border-2 rounded-xl p-2 overflow-y-auto">
                        <textarea
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            className="w-full bg-white border-none outline-none resize-none overflow-hidden"
                            rows={5}
                            style={{ height: 'auto' }}
                            readOnly={!isEditable}
                        />
                    </div>
                    {(isEditable || Seller) && negotiationStatus !== 'Accepted' && (
                        <button
                            className="w-fit px-6 bg-green-500 hover:bg-transparent hover:bg-white-500 font-semibold hover:text-black font-pop text-lg py-2 border border-black-500 hover:border-green-500 rounded-full text-white"
                            onClick={buttonHandler}>
                            {Seller ? 'Accept changes' : 'Negotiate'}
                        </button>
                    )}
                </div>
            )}
        </>
    );
};

export default Negotiate;